import React, { CSSProperties, FC } from 'react';
import cn from 'clsx';
import { twMerge } from 'tailwind-merge';

interface Props {
  id?: string;
  style?: CSSProperties;
  className?: string;
  children?: React.ReactNode;
  el?: HTMLElement | string;
}

const Container: FC<Props> = ({ id, children, className, el = 'div', style }) => {
  const rootClassName = cn(twMerge('container mx-auto px-5', className));

  let Component: React.ComponentType<React.HTMLAttributes<HTMLDivElement>> = el as any;

  return (
    <Component id={id} className={rootClassName} style={style}>
      {children}
    </Component>
  );
};

export default Container;
